module.exports = __webpack_public_path__ + "img/cq-preview.f27be2c7.jpg";